"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HUBSPOT_FRAUD_CLAUDIT_CONTACTED_CASE_TYPES = exports.HUBSPOT_FRAUD_CLAUDIT_CASE_TYPE = exports.HubspotAccountOwner = exports.HubspotUserStatus = exports.HubspotLastPaymentCategory = exports.HubspotApiAction = exports.HubspotStatus = exports.OnboardingQualification = exports.NewServiceEntry = void 0;
var NewServiceEntry;
(function (NewServiceEntry) {
    NewServiceEntry["Donation"] = "Donation";
    NewServiceEntry["Event"] = "Event";
    NewServiceEntry["P2P"] = "P2P";
    NewServiceEntry["Membership"] = "Membership";
    NewServiceEntry["Raffle"] = "Raffle";
    NewServiceEntry["Other"] = "Other";
})(NewServiceEntry || (exports.NewServiceEntry = NewServiceEntry = {}));
var OnboardingQualification;
(function (OnboardingQualification) {
    OnboardingQualification["Small"] = "Small";
    OnboardingQualification["Medium"] = "Medium";
    OnboardingQualification["Large"] = "Large";
    OnboardingQualification["Other"] = "Other";
})(OnboardingQualification || (exports.OnboardingQualification = OnboardingQualification = {}));
var HubspotStatus;
(function (HubspotStatus) {
    HubspotStatus[HubspotStatus["ExistingContact"] = 409] = "ExistingContact";
    HubspotStatus[HubspotStatus["UpdateSucceeded"] = 204] = "UpdateSucceeded";
})(HubspotStatus || (exports.HubspotStatus = HubspotStatus = {}));
var HubspotApiAction;
(function (HubspotApiAction) {
    HubspotApiAction["Create"] = "Create";
    HubspotApiAction["Update"] = "Update";
    HubspotApiAction["Merge"] = "Merge";
    HubspotApiAction["Get"] = "Get";
})(HubspotApiAction || (exports.HubspotApiAction = HubspotApiAction = {}));
var HubspotLastPaymentCategory;
(function (HubspotLastPaymentCategory) {
    HubspotLastPaymentCategory["DonationForm"] = "DonationForm";
    HubspotLastPaymentCategory["PeerToPeer"] = "PeerToPeer";
    HubspotLastPaymentCategory["Membership"] = "Membership";
    HubspotLastPaymentCategory["Raffle"] = "Raffle";
    HubspotLastPaymentCategory["Sweepstakes"] = "Sweepstakes";
    HubspotLastPaymentCategory["Ticketing"] = "Ticketing";
    HubspotLastPaymentCategory["Auction"] = "Auction";
})(HubspotLastPaymentCategory || (exports.HubspotLastPaymentCategory = HubspotLastPaymentCategory = {}));
var HubspotUserStatus;
(function (HubspotUserStatus) {
    HubspotUserStatus["Creator"] = "Creator";
    HubspotUserStatus["Member"] = "Member";
})(HubspotUserStatus || (exports.HubspotUserStatus = HubspotUserStatus = {}));
var HubspotAccountOwner;
(function (HubspotAccountOwner) {
    HubspotAccountOwner["Admin"] = "Admin";
    HubspotAccountOwner["Member"] = "Member";
})(HubspotAccountOwner || (exports.HubspotAccountOwner = HubspotAccountOwner = {}));
exports.HUBSPOT_FRAUD_CLAUDIT_CASE_TYPE = {
    RestrictedBusiness: "1A",
    UccLien: "2",
    Sanction: "3A",
    Clear: "Clear",
};
exports.HUBSPOT_FRAUD_CLAUDIT_CONTACTED_CASE_TYPES = [
    exports.HUBSPOT_FRAUD_CLAUDIT_CASE_TYPE.RestrictedBusiness,
    exports.HUBSPOT_FRAUD_CLAUDIT_CASE_TYPE.UccLien,
    exports.HUBSPOT_FRAUD_CLAUDIT_CASE_TYPE.Sanction,
];
